:host(:not([state='is-active'])) {
  .main-container .section-content .chart-legend-container .chart-legend .chart-legend-item:hover {
    cursor: default;
    color: var(--main-titles-inputs-600);
  }
}
